import React from 'react';

import { LoginFormContainerWithRouter } from '../containers/LoginForm.container';

const LoginPage = () => <LoginFormContainerWithRouter />;

export { LoginPage };
